module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "flex flex-col md:flex-row items-start md:items-center justify-between w-full mb-4 space-y-2 md:space-y-0 md:space-x-2"
  }, [_c('div', {
    staticClass: "relative font-manrope w-full md:w-1/2"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchStudents),
      expression: "searchStudents"
    }],
    staticClass: "py-2 w-full text-sm text-gray-700 pl-10 pr-4 border border-gray-200 rounded outline-none ring-offset-1 focus:ring-2 focus:ring-primary transition",
    attrs: {
      "aria-autocomplete": "none",
      "type": "text",
      "placeholder": "Search...",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.searchStudents)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchStudents = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col sm:flex-row items-stretch sm:items-center w-full md:w-auto space-y-2 sm:space-y-0 sm:space-x-2"
  }, [(_vm.studentsSelectedToDelete.length === 0) ? _c('label', {
    staticClass: "cursor-pointer flex-1 sm:flex-none flex justify-center items-center space-x-2 px-5 py-2 bg-gray-800 hover:bg-gray-900 text-white rounded font-manrope transition",
    attrs: {
      "for": "fileUpload"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.isAddingStudents ? 'Importing...' : 'Import'))]), _vm._v(" "), (_vm.isAddingStudents) ? _c('div', {
    staticClass: "loader"
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "fileToUpload",
    staticClass: "hidden",
    attrs: {
      "id": "fileUpload",
      "type": "file",
      "accept": ".csv",
      "disabled": _vm.$route.params.courseID === _vm.$store.state.course_sample_id
    },
    on: {
      "change": _vm.selectFileToUpload
    }
  }), _vm._v(" "), (_vm.studentsSelectedToDelete.length > 0) ? _c('button', {
    staticClass: "flex-1 sm:flex-none flex justify-center items-center px-5 py-2 bg-red-500 hover:bg-red-600 disabled:bg-red-300 text-white rounded font-manrope transition",
    attrs: {
      "disabled": _vm.studentsSelectedToDelete.length === 0
    },
    on: {
      "click": function($event) {
        _vm.isModalDeleteParticipantsOpen = true
      }
    }
  }, [_vm._v("\n        Remove (" + _vm._s(_vm.studentsSelectedToDelete.length) + ")\n      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('div', {
    staticClass: "overflow-x-auto sm:-mx-6 lg:-mx-8"
  }, [_c('div', {
    staticClass: "inline-block min-w-full sm:px-6 lg:px-8"
  }, [(_vm.studentsFiltered.length === 0) ? _c('div', {
    staticClass: "px-4"
  }, [_c('span', {
    staticClass: "text-gray-400"
  }, [_vm._v("No students found.")])]) : _c('div', {
    staticClass: "overflow-hidden rounded"
  }, [_c('table', {
    staticClass: "min-w-full border rounded"
  }, [_c('thead', {
    staticClass: "border-b font-manrope text-gray-700 font-normal"
  }, [_c('tr', [_c('th', {
    staticClass: "w-10 text-sm px-6 py-2.5 text-left",
    attrs: {
      "scope": "col"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isAllSelected),
      expression: "isAllSelected"
    }],
    staticClass: "cursor-pointer",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isAllSelected) ? _vm._i(_vm.isAllSelected, null) > -1 : (_vm.isAllSelected)
    },
    on: {
      "click": function($event) {
        return _vm.selectAllStudents($event)
      },
      "change": function($event) {
        var $$a = _vm.isAllSelected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isAllSelected = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isAllSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isAllSelected = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "w-4/12 px-4 py-2.5 text-left",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                  Full Name\n                  "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.sortByStudentName()
      }
    }
  }, [_c('i', {
    staticClass: "ml-2 fa",
    class: !_vm.isOrdering ? 'fa-angle-down' : 'fa-angle-up'
  })])]), _vm._v(" "), _c('th', {
    staticClass: "w-5/12 px-6 py-2.5 text-left",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                  E-mail\n                ")]), _vm._v(" "), _c('th', {
    staticClass: "w-1/6 px-6 py-2.5 text-left",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                  RoundTables\n                  "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.sortByNumberOfRoundTables()
      }
    }
  }, [_c('i', {
    staticClass: "ml-2 fa",
    class: !_vm.isOrderingByRTs ? 'fa-angle-down' : 'fa-angle-up'
  })])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.studentsFiltered), function(student, index) {
    return _c('tr', {
      key: index,
      staticClass: "border-b hover:bg-gray-50 font-manrope"
    }, [_c('td', {
      staticClass: "py-2.5 px-6"
    }, [(!student.subscription.created_from_clever) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedStudents[index]),
        expression: "selectedStudents[index]"
      }],
      staticClass: "cursor-pointer",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.selectedStudents[index]) ? _vm._i(_vm.selectedStudents[index], null) > -1 : (_vm.selectedStudents[index])
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.selectedStudents[index],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.selectedStudents, index, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.selectedStudents, index, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.selectedStudents, index, $$c)
          }
        }, function($event) {
          _vm.handleSelectStudents(), _vm.updateCheckAll()
        }]
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "pt-3 px-4 flex items-center"
    }, [_c('img', {
      staticClass: "rounded-full h-6 w-6 mr-3",
      attrs: {
        "src": student.avatar_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "flex items-center cursor-pointer"
    }, [_c('span', {
      staticClass: "hover:underline",
      on: {
        "click": function($event) {
          return _vm.viewStudentReport(student.id)
        }
      }
    }, [_vm._v(_vm._s(student.name))]), _vm._v(" "), (student.pending) ? _c('span', {
      staticClass: "text-primary ml-0.5"
    }, [_vm._v("(Pending)")]) : _vm._e()])]), _vm._v(" "), _c('td', {
      staticClass: "py-2.5 px-6"
    }, [_c('a', {
      staticClass: "text-gray-600 hover:underline",
      attrs: {
        "href": 'mailto:' + student.email
      }
    }, [_vm._v(_vm._s(student.email))])]), _vm._v(" "), _c('td', {
      staticClass: "py-2.5 px-6"
    }, [_c('span', {
      staticClass: "text-center ml-10"
    }, [_vm._v(_vm._s(_vm.sumOfRoundTables(student.rts_count, student.lives_count)))])])])
  }), 0)])])])])]), _vm._v(" "), (_vm.isModalDeleteParticipantsOpen) ? _c('DeleteDialog', {
    attrs: {
      "message": 'Remove Students ' + '(' + _vm.studentsSelectedToDelete.length + ')',
      "confirmColor": 'bg-red-500 hover:bg-red-600',
      "confirmText": 'DELETE',
      "typeConfirm": false
    },
    on: {
      "close": function($event) {
        _vm.isModalDeleteParticipantsOpen = false
      },
      "confirm": function($event) {
        return _vm.deleteSelectedStudents()
      }
    }
  }, [_c('div', {
    staticClass: "text-center text-gray-700 my-10"
  }, [_c('i', {
    staticClass: "fa-solid fa-circle-exclamation text-red-500 text-4xl mb-5"
  }), _vm._v(" "), _c('p', {
    staticClass: "text-center mx-12"
  }, [_vm._v("\n        Are you sure you want to remove this students\n        "), _c('span', {
    staticClass: "font-bold"
  }), _vm._v(" from the course? This action is\n        irreversible and students will lose all their activity.\n      ")])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "absolute text-gray-600 top-2.5 left-0 flex items-center pl-4"
  }, [_c('button', {
    staticClass: "focus:outline-none focus:shadow-outline focus-within:text-primary -mb-0.5",
    attrs: {
      "type": "submit",
      "aria-label": "Search"
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-magnifying-glass"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-3296846a!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/courses/pages/settings/ParticipantsTable.vue
// module id = 2227
// module chunks = 61